// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vpV4E","iconContainer":"styles_iconContainer__x2CXj"};